import { Center, Text } from "@reverb-ui/react";
import { useMemo } from "react";

type ResultCellProps = {
  percentage: string;
  children: React.ReactNode;
};

export const ResultCell = ({ children, percentage }: ResultCellProps) => {
  const percentageNumber = useMemo(
    () => parseFloat(percentage.split("%")[0].replace("(", "")),
    [percentage]
  );

  const colorAndBgColor = {
    bg: "",
    color: "",
  };

  if (percentageNumber === 0) {
    colorAndBgColor.bg = "blue.50";
    colorAndBgColor.color = "neutral.600";
  } else if (percentageNumber < 26) {
    colorAndBgColor.bg = "primary.100";
    colorAndBgColor.color = "primary.900";
  } else if (percentageNumber < 51) {
    colorAndBgColor.bg = "primary.200";
    colorAndBgColor.color = "neutral.50";
  } else if (percentageNumber < 76) {
    colorAndBgColor.bg = "primary.500";
    colorAndBgColor.color = "neutral.50";
  } else {
    colorAndBgColor.bg = "primary.800";
    colorAndBgColor.color = "neutral.50";
  }
  return (
    <Center flex={1} width="full" {...colorAndBgColor} py={2}>
      <Text fontSize="sm">{children}</Text>
    </Center>
  );
};
